import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/montserrat';
import './index.css';
import './i18n';
import { QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { AppAbilityProvider } from '@/authorization/app-ability-provider';
import { GlobalLoadingIndicator } from '@/components/loading-indicators/loading-global-indicator';
import { AuthProvider } from '@/components/providers/auth-provider';
import { ThemeProvider } from '@/components/theme-provider';
import { routeTree } from '@/routes/route-tree';
import { queryClient } from '@/services/apis/query-client';
import { trace } from '@/tracing';

trace();

const router = createRouter({ routeTree });

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <AuthProvider>
      <AppAbilityProvider>
        <NuqsAdapter>
          <ThemeProvider>
            <QueryClientProvider client={queryClient}>
              <GlobalLoadingIndicator />
              <RouterProvider router={router} />
            </QueryClientProvider>
          </ThemeProvider>
        </NuqsAdapter>
      </AppAbilityProvider>
    </AuthProvider>
  </StrictMode>,
);
